module.exports = __webpack_public_path__ + "static/media/qingdao_pic1.f9226819.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/qingdao_pic1.jpg
 ** module id = 470
 ** module chunks = 0
 **/